/**
 * Opening stock entry route — mounts `<OpeningBalancePage />`.
 *
 * @see apps/web/src/features/inventory/stock/opening-balance-page.tsx
 */
import { createFileRoute } from "@tanstack/react-router";
import { OpeningBalancePage } from "../../../../features/inventory/index.ts";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";

export const Route = createFileRoute("/(workspace)/inventory/stock/opening")({
  component: StockOpeningRoute,
});

function StockOpeningRoute() {
  return (
    <WorkspaceShell
      breadcrumbs={[
        { label: "Inventory", to: "/" },
        { label: "Stock", to: "/inventory/stock" },
        { label: "Opening stock" },
      ]}
    >
      <OpeningBalancePage />
    </WorkspaceShell>
  );
}
